module.exports = __webpack_public_path__ + "static/media/BRUCE LIPTON.40d13de7.jpg";